import styled from '@emotion/styled'



/** Root layout wrapper for the customers browse page (search + table stack). */
export const StyledCustomers = styled.div`


    display: flex;
    flex-direction: column;
    gap: 40px;

`
